import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/header.css";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setOpenDropdown(null);
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  return (
    <header className={`modern-header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="header-container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="header-logo">
            {/* <span className="logo-text">Profit Technologies</span> */}
            <img src={require('../assets/images/c-logo.png')} alt="Solaris" className="logo-image" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <ul className="nav-menu">
              <li className="nav-item dropdown-item">
                <span className="nav-link">
                  Our Company
                  <svg className="dropdown-icon" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <div className="dropdown-menu">
                  <Link to="/about" className="dropdown-link">About Us</Link>
                  <Link to="/career" className="dropdown-link">Career</Link>
                  <Link to="/clients" className="dropdown-link">Clients</Link>
                  <Link to="/sustainability" className="dropdown-link">Sustainability</Link>
                  <Link to="/diversity-inclusion" className="dropdown-link">Diversity &amp; Inclusion</Link>
                </div>
              </li>

              <li className="nav-item dropdown-item">
                <span className="nav-link">
                  Services
                  <svg className="dropdown-icon" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>

                <div className="dropdown-menu">
                  <Link to="/services/enterprise-networking" className="dropdown-link">Enterprise Networking Services</Link>
                  <Link to="/services/cyber-security" className="dropdown-link">Cyber Security</Link>
                  <Link to="/services/collaboration-services" className="dropdown-link">Collaboration Services</Link>
                  <Link to="/services/data-center" className="dropdown-link">Data Center</Link>
                  <Link to="/services/managed-services" className="dropdown-link">Managed Services</Link>

                  <Link to="/services/professional-services" className="dropdown-link">Professional Services</Link>

                </div>

              </li>
              <li className="nav-item">
                <Link to="/industries" className="nav-link">Industries</Link>
              </li>

              {/* <li className="nav-item">
                <Link to="/portfolio" className="nav-link">PORTFOLIO</Link>
              </li> */}
              <li className="nav-item">
                <Link to="/partners" className="nav-link">Partner</Link>
              </li>

              <li className="nav-item dropdown-item">
                <span className="nav-link">
                  Insights
                  <svg className="dropdown-icon" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <div className="dropdown-menu">
                  <Link to="/case-study" className="dropdown-link">Case Studies</Link>
                  <Link to="/blogs" className="dropdown-link">Blogs</Link>
                  <Link to="/events" className="dropdown-link">Events</Link>
                </div>
              </li>

              <li className="nav-item">
                <Link to="/contact" className="nav-link nav-link-cta">GET IN TOUCH</Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="mobile-menu">

            <li className="mobile-nav-item">
              <Link to="/" className="mobile-nav-link" onClick={toggleMobileMenu}>HOME</Link>
            </li>

            {/* Our Company dropdown */}
            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={() => toggleDropdown('company')}>
                OUR COMPANY
                <svg className={`dropdown-icon ${openDropdown === 'company' ? 'rotated' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`mobile-dropdown ${openDropdown === 'company' ? 'open' : ''}`}>
                <Link to="/about" className="mobile-dropdown-link" onClick={toggleMobileMenu}>About Us</Link>
                <Link to="/career" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Career</Link>
                <Link to="/clients" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Clients</Link>
                <Link to="/sustainability" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Sustainability</Link>
                <Link to="/diversity-inclusion" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Diversity &amp; Inclusion</Link>
              </div>
            </li>

            {/* Services dropdown */}
            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={() => toggleDropdown('services')}>
                SERVICES
                <svg className={`dropdown-icon ${openDropdown === 'services' ? 'rotated' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`mobile-dropdown ${openDropdown === 'services' ? 'open' : ''}`}>
                <Link to="/services/enterprise-networking" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Enterprise Networking Services</Link>
                <Link to="/services/cyber-security" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Cyber Security</Link>
                <Link to="/services/collaboration-services" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Collaboration Services</Link>
                <Link to="/services/data-center" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Data Center</Link>
                <Link to="/services/managed-services" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Managed Services</Link>
                <Link to="/services/professional-services" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Professional Services</Link>
              </div>
            </li>

            <li className="mobile-nav-item">
              <Link to="/industries" className="mobile-nav-link" onClick={toggleMobileMenu}>INDUSTRIES</Link>
            </li>

            <li className="mobile-nav-item">
              <Link to="/partners" className="mobile-nav-link" onClick={toggleMobileMenu}>PARTNER</Link>
            </li>

            {/* Insights dropdown */}
            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={() => toggleDropdown('insights')}>
                INSIGHTS
                <svg className={`dropdown-icon ${openDropdown === 'insights' ? 'rotated' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`mobile-dropdown ${openDropdown === 'insights' ? 'open' : ''}`}>
                <Link to="/case-study" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Case Studies</Link>
                <Link to="/blogs" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Blogs</Link>
                <Link to="#" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Events</Link>
              </div>
            </li>

            <li className="mobile-nav-item">
              <Link to="/contact" className="mobile-nav-link mobile-nav-link-cta" onClick={toggleMobileMenu}>GET IN TOUCH</Link>
            </li>

          </ul>
        </div>
      </div>
    </header >
  );
}

export default Header;
